export const GET_GOAL_SUCCEED = 'Goal/GET_GOAL_SUCCEEDED';
export const GET_GOAL_ERROR = 'Goal/GET_GOAL_ERROR';
export const LOADING_STATE = 'Goal/LOADING_STATE';

export const CREATE_GOAL_SUCCEED = 'Goal/CREATE_GOAL_SUCCEEDED';
export const CREATE_GOAL_ERROR = 'Goal/CREATE_GOAL_ERROR';

export const GET_EXERCISES_SUCCEED = 'exercises/GET_EXERCISES_SUCCEED';
export const GET_EXERCISES_ERROR = 'exercises/GET_EXERCISES_ERROR';
export const EXERCISE_LOADING_STATE = 'exercises/EXERCISE_LOADING_STATE';